import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import $script from 'scriptjs';

import config from 'config';

import { handleError } from '@mssgme/lib';
import { useActions } from '@mssgme/hooks';
import { useIntegration } from '../useIntegration';

export const useVkIntegration = () => {
    const { api } = useActions();
    const { t, rootIntegrationsPath } = useIntegration();
    const history = useHistory();
    const [isFetching, setIsFetching] = useState(false); // TODO: remove
    const [isConnected, setIsConnected] = useState(false); // TODO: remove
    const [vk, setVk] = useState(null);
    const [groups, setGroups] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [username, setUsername] = useState('');
    const [step, setStep] = useState(1);
    const [errors, setErrors] = useState({}); // TODO: remove
    const [plugError, setPlugError] = useState(null);
    const [popup, setPopup] = useState(null);

    const initVk = () => {
        $script('https://vk.com/js/api/openapi.js?158', () => {
            const vk = window.VK;

            if (vk) {
                vk.init({
                    apiId: config.vk_app_id,
                });

                setVk(vk);
            } else {
                setPlugError('vkIntegration.errors.plug_failed');
            }
        });
    };

    const handleLoginClick = (e) => {
        e.preventDefault();

        vk.Auth.login((res) => {
            const isConnected = res.status === 'connected';

            if (isConnected) {
                const user = res.session.user;
                const username = `${user.first_name} ${user.last_name}`.trim();

                setIsConnected(isConnected);
                setStep(2);
                setUsername(username);

                loadGroups();
            }
        }, 262144);
    };

    const getGroupsOptions = () => {
        return groups.map(({ id, name }) => ({ value: id, label: name }));
    };

    const loadGroups = () => {
        vk.Api.call('groups.get', { filter: 'admin', extended: 1, v: '5.81' }, (res) => {
            setGroups(res.response.items.map((item) => ({ ...item, id: item.id.toString() })));
        });
    };

    const handleChange = (e) => {
        const value = e.target.value;
        const selectedGroup = groups.find((item) => item.id === value);

        setSelectedGroup(selectedGroup);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const url = `https://oauth.vk.com/authorize?client_id=${config.vk_app_id}&display=popup&redirect_uri=${
            config.vk_callback_url
        }&group_ids=${selectedGroup.id}&scope=manage,messages,photos,docs&response_type=code&v=5.81`;
        setPopup(window.open(url, '_blank', 'height=400,width=300'));
    };

    const onAuthorize = async (res) => {
        const token = res[`access_token_${selectedGroup.id}`];

        try {
            await api.integrations.create({ payload: { type: 'vk', token, groupId: selectedGroup.id } });

            popup.close();
            history.push(rootIntegrationsPath);
        } catch (e) {
            handleError(e);
        }
    };

    useEffect(() => {
        initVk();
        window.onAuthorizeVK = onAuthorize;
    }, []);

    useEffect(() => {
        window.onAuthorizeVK = onAuthorize;
    }, [selectedGroup, popup]);

    return {
        t,
        vk,
        plugError,
        step,
        handleLoginClick,
        handleSubmit,
        username,
        selectedGroup,
        getGroupsOptions,
        handleChange,
        errors,
        isFetching,
    };
};
